import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Role } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class UserRoleService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  async getRoles(
    parameters: any = {
      sort: 'name',
      direction: 'asc',
    },
    schema: any = { id: null, name: null }
  ): Promise<Role[]> {
    return await this.core.services.userRole.getList(parameters, schema)
  }
}
